// extracted by mini-css-extract-plugin
export default {"CybershoreContainer":"cybershore_game_CybershoreContainer__J95D7"};